import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { ec2Get, ec2Post } from '../utils/ec2api';

export default function Comisiones() {
  const [codigos, setCodigos] = useState([]);
  const [comisiones, setComisiones] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [nombre, setNombre] = useState('');
  const [codigo, setCodigo] = useState('');
  const [pct, setPct] = useState('10');
  const [idVendedor, setIdVendedor] = useState('');
  const [creando, setCreando] = useState(false);

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      setCodigos(await ec2Get('/codigos'));
      setComisiones(await ec2Get('/comisiones'));
    } catch (e) { console.error(e); }
  };



  
  const crearCodigo = async () => {
    if (!nombre || !codigo) { toast.warn('Completa nombre y código'); return; }
    setCreando(true);
    try {
      await ec2Post('/codigos', { codigo, id_vendedor: parseInt(idVendedor) || 0, nombre, comision_pct: parseFloat(pct) || 10 });
      toast.success('✅ Agencia creada correctamente');
      setNombre(''); setCodigo(''); setPct('10'); setIdVendedor(''); setShowForm(false);
      load();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch { toast.error('Error al crear'); }
    finally { setCreando(false); }
  };

  const totalComisiones = comisiones.reduce((s, c) => s + (parseFloat(c.comision_monto) || 0), 0);
  const totalVentas = comisiones.reduce((s, c) => s + (parseFloat(c.precio) || 0), 0);
  const [mesComision, setMesComision] = useState('todos');

  const mesesComision = [...new Set(comisiones.map(c => {
    const d = c.created_at ? c.created_at.substring(0, 7) : '';
    return d;
  }).filter(Boolean))].sort().reverse();

  const comisionesFiltradas = mesComision === 'todos'
    ? comisiones
    : comisiones.filter(c => c.created_at && c.created_at.startsWith(mesComision));

  const totalComFiltradas = comisionesFiltradas.reduce((s, c) => s + (parseFloat(c.comision_monto) || 0), 0);
  const totalVentasFiltradas = comisionesFiltradas.reduce((s, c) => s + (parseFloat(c.precio) || 0), 0);

  const descargarCSV = () => {
    const headers = ['Fecha', 'Agencia', 'Código', 'Cliente', 'Paquete', 'Precio', '% Comisión', 'Monto Comisión', 'Estatus'];
    const rows = comisionesFiltradas.map(c => [
      c.created_at, c.nombre_vendedor || '', c.codigo_vendedor, c.cliente_email,
      c.paquete, c.precio, c.comision_pct, c.comision_monto, c.estatus
    ]);
    const csv = [headers, ...rows].map(r => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `comisiones_${mesComision}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const inputStyle = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ccc', marginBottom: '10px', boxSizing: 'border-box' };

  return (
    <div style={{ marginTop: '20px' }}>
      <h2>💰 Comisiones Agencias</h2>

      {/* Explicación */}
      <div style={{ background: '#e8f0fe', borderRadius: '14px', padding: '16px', marginBottom: '20px', fontSize: '13px', color: '#1b2938', lineHeight: '1.6' }}>
        <strong>¿Cómo funciona?</strong>
        <ol style={{ margin: '8px 0 0 16px', padding: 0 }}>
          <li>Crea una agencia con un código único y su % de comisión</li>
          <li>La agencia comparte su código con sus clientes</li>
          <li>El cliente pone el código en "Código promocional" al comprar eSIM Internacional</li>
          <li>La comisión se registra automáticamente aquí</li>
        </ol>
      </div>

      {/* Resumen */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '20px' }}>
        <div style={{ background: '#e8f0fe', borderRadius: '14px', padding: '16px', textAlign: 'center' }}>
          <div style={{ fontSize: '24px', fontWeight: '800', color: '#1b2938' }}>{codigos.length}</div>
          <div style={{ fontSize: '12px', color: '#4b5563' }}>Agencias</div>
        </div>
        <div style={{ background: '#dcfce7', borderRadius: '14px', padding: '16px', textAlign: 'center' }}>
          <div style={{ fontSize: '24px', fontWeight: '800', color: '#166534' }}>${totalVentasFiltradas.toLocaleString()}</div>
          <div style={{ fontSize: '12px', color: '#4b5563' }}>Ventas</div>
        </div>
        <div style={{ background: '#fef3c7', borderRadius: '14px', padding: '16px', textAlign: 'center' }}>
          <div style={{ fontSize: '24px', fontWeight: '800', color: '#92400e' }}>${totalComFiltradas.toLocaleString()}</div>
          <div style={{ fontSize: '12px', color: '#4b5563' }}>Comisiones</div>
        </div>
      </div>

      {/* Agencias */}
      <div style={{ background: '#fff', borderRadius: '16px', padding: '20px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
          <h3 style={{ margin: 0, fontSize: '16px', color: '#1b2938' }}>🏢 Agencias</h3>
          <button onClick={() => setShowForm(!showForm)} style={{
            padding: '8px 16px', borderRadius: '10px', background: '#1b2938', color: '#fff',
            border: 'none', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
          }}>
            {showForm ? 'Cancelar' : '+ Nueva Agencia'}
          </button>
        </div>

        {showForm && (
          <div style={{ padding: '16px', background: '#f7f9fc', borderRadius: '12px', marginBottom: '14px' }}>
            <input placeholder="Nombre de la agencia *" value={nombre} onChange={(e) => setNombre(e.target.value)} style={inputStyle} />
            <input placeholder="Código promocional *" value={codigo} onChange={(e) => setCodigo(e.target.value.toUpperCase())} style={inputStyle} />
            <input placeholder="ID vendedor (opcional)" value={idVendedor} onChange={(e) => setIdVendedor(e.target.value)} style={inputStyle} />
            <input type="number" placeholder="% Comisión (default 10)" value={pct} onChange={(e) => setPct(e.target.value)} style={inputStyle} />
            <button onClick={crearCodigo} disabled={creando} className="orange-button" style={{ width: '100%' }}>
              {creando ? '⏳...' : 'Crear Agencia'}
            </button>
          </div>
        )}

        {codigos.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '20px', color: '#9ca3af' }}>No hay agencias registradas</div>
        ) : (
          codigos.map(c => (
            <div key={c.id} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '12px', background: '#f9fafb', borderRadius: '10px', marginBottom: '8px',
            }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#1b2938' }}>{c.nombre}</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>Código: <strong>{c.codigo}</strong> · {c.comision_pct}%</div>
              </div>
              <span style={{ padding: '4px 12px', background: '#dcfce7', borderRadius: '20px', fontSize: '12px', fontWeight: '600', color: '#166534' }}>
                Activa
              </span>
            </div>
          ))
        )}
      </div>

      {/* Historial de comisiones */}
      <div style={{ background: '#fff', borderRadius: '16px', padding: '20px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', flexWrap: 'wrap', gap: '8px' }}>
          <h3 style={{ margin: 0, fontSize: '16px', color: '#1b2938' }}>📋 Historial de Comisiones</h3>
          <div style={{ display: 'flex', gap: '8px' }}>
            <select value={mesComision} onChange={(e) => setMesComision(e.target.value)}
              style={{ padding: '8px 12px', borderRadius: '10px', border: '1px solid #ccc', fontSize: '13px' }}>
              <option value="todos">Todos</option>
              {mesesComision.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
            <button onClick={descargarCSV} style={{
              padding: '8px 16px', borderRadius: '10px', background: '#1b2938', color: '#fff',
              border: 'none', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
            }}>📥 CSV</button>
          </div>
        </div>
        {comisionesFiltradas.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '20px', color: '#9ca3af' }}>Sin comisiones aún</div>
        ) : (
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {comisionesFiltradas.map(c => (
              <div key={c.id} style={{
                padding: '12px', background: '#f9fafb', borderRadius: '10px', marginBottom: '8px',
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ fontWeight: 700, fontSize: 14, color: '#1b2938' }}>{c.nombre_vendedor || c.codigo_vendedor}</span>
                  <span style={{ fontWeight: 700, fontSize: 14, color: '#166534' }}>+${parseFloat(c.comision_monto || 0).toFixed(2)}</span>
                </div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>
                  {c.paquete} · ${parseFloat(c.precio || 0).toFixed(2)} · {c.comision_pct}% · {c.cliente_email}
                </div>
                <div style={{ fontSize: 11, color: '#9ca3af', marginTop: '2px' }}>
                  {new Date(c.created_at).toLocaleString()} · {c.estatus}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div style={{ height: 80 }} />
    </div>
  );
}
